module.exports = __webpack_public_path__ + "img/01_img.62f3e62b.png";